module.exports = __webpack_public_path__ + "img/infield-mezzanine.2328c0f2.svg";